import {
  Box,
  Container,
  ContentLayout,
  Link,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import useAxios, {
  configure,
  loadCache,
  serializeCache,
  makeUseAxios,
} from 'axios-hooks'
import { leagueId } from '../../../leagueId';
import { RotatingLines, ThreeDots, BallTriangle } from  'react-loader-spinner'
import * as awsui from "@cloudscape-design/design-tokens";
import { useMediaQuery } from 'react-responsive';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { CustomButton } from "../../../components/buttons";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { useNavigate, useLocation } from "react-router-dom";
import { navigateFn } from "../../../routingHelper";
import SeriesNav from "../../../components/series-navbar/series-nav";
import GetSeriesContent from "../get-series-content";
import Rules from "./rules";
import Gallery from "./gallery";
import Series from "./series";
import Register from './register';
import Results from "./results";
import Calendar from "./calendar";
import DriversAndTeams from "./teams";
import Stats from "./stats";



export default function F3A_Series() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    theme, setTheme, 
    density, setDensity,
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);

  return (
    <>
      <center>
        <div className="body-content">
          <ContentLayout
            header={
              <div className="series-header-container">
                <img 
                  className="series-header-img"
                  src={theme === Mode.Light ? "/images/f3a/f3a-header-light.png" : "/images/f3a/f3a-header-light.png"}
                  alt="F3A Logo"
                />
              </div>
            }
          >
              <Container>
                <SeriesNav />
              </Container>
            </ContentLayout>
          </div>
          <div style={{
            marginTop: "50px",
            maxWidth: "1600px",
          }}> 
            {GetSeriesContent(seriesContent, Series, Results, Calendar, Rules, DriversAndTeams, Stats, Gallery, Register, Results )}
          </div>
        </center>
    </>    
  );
}
